'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'pen-nib';
var width = 512;
var height = 512;
var aliases = [10001];
var unicode = 'f5ad';
var svgPathData = 'M368.5 18.3c21.9-21.9 57.3-21.9 79.2 0l46.1 46.1c21.9 21.9 21.9 57.3 0 79.2l-71 71-10.4 10.4-40.7 149.1c-4.8 17.8-18.1 32-35.5 38.1L72 505c-18.5 6.5-39.1 1.8-52.9-12S.5 458.5 7 440L99.8 175.9c6.1-17.4 20.3-30.6 38.1-35.5l149.1-40.7 10.4-10.4 71-71zM296.9 146.8L150.6 186.7c-2.5 .7-4.6 2.6-5.4 5.1L65.6 418.2 163 320.7c-1.9-5.2-3-10.8-3-16.7 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-5.9 0-11.5-1.1-16.7-3l-97.5 97.5 226.4-79.5c2.5-.9 4.4-2.9 5.1-5.4l39.9-146.4-68.3-68.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenNib = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;